import React, { useCallback, useState, useRef } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { FiEdit, FiSave, FiTrash, FiXCircle } from 'react-icons/fi';

import { useToast } from '../../../hooks/toast';
import InputMoney from '../../InputMoney';

import getValidationErrors from '../../../utils/getValidationErrors';
import { formatPrice } from '../../../utils/funcoes';

import Modal from '../../Modal';
import {
  IValoresProcedimento,
  IValorProcedimento,
  useProcedimento,
} from '../../../hooks/procedimentos';
import Input from '../../Input';

interface componentProps {
  valorConvenio: IValoresProcedimento;
  handleDeletou(ConvCodigo: number): void;
}
interface IFormDados {
  valor: number;
  ProRetorno: number;
}

const LinhaValor: React.FC<componentProps> = ({
  valorConvenio,
  handleDeletou,
}) => {
  const { addToast } = useToast();
  const { addValorConvenio, deleteValorConvenio } = useProcedimento();
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [showAlterar, setShowAlterar] = useState(false);
  const [showExcluir, setShowExcluir] = useState(false);
  const [
    valorConvenioLocal,
    setvalorConvenioLocal,
  ] = useState<IValoresProcedimento>(valorConvenio);
  const formRefValor = useRef<FormHandles>(null);

  const handleAlterarValor = useCallback(
    async (dados: IFormDados) => {
      try {
        setLoading(true);
        formRefValor.current?.setErrors({});
        const schema = Yup.object().shape({
          valor: Yup.number().required(),
          ProRetorno: Yup.number().required(),
        });

        await schema.validate(dados, {
          abortEarly: false,
        });

        const dadosFormatados: IValorProcedimento = {
          ConvCodigo: valorConvenioLocal.ConvCodigo,
          ProCodigo: valorConvenioLocal.ProCodigo,
          valor: dados.valor,
          ProRetorno: dados.ProRetorno,
        };

        await addValorConvenio(dadosFormatados, valorConvenio.convenio || '');

        setvalorConvenioLocal(state => {
          return {
            ...state,
            valor: dados.valor,
            valorFormatado: formatPrice(dados.valor),
            ProRetorno: dados.ProRetorno,
          };
        });
        setShowAlterar(false);
      } catch (error: any) {
        console.log(error);
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefValor.current?.setErrors(errors);
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro ao atualizar valor',
          description: error?.response?.data?.message
            ? error?.response?.data?.message
            : error.message,
        });
      } finally {
        setLoading(false);
      }
    },
    [
      addToast,
      valorConvenioLocal.ConvCodigo,
      valorConvenioLocal.ProCodigo,
      valorConvenio.convenio,
      addValorConvenio,
    ],
  );

  const handleDeleteValor = useCallback(async () => {
    try {
      setLoadingDelete(true);

      await deleteValorConvenio(
        valorConvenioLocal.ProCodigo,
        valorConvenioLocal.ConvCodigo,
      );

      setShowExcluir(false);
      handleDeletou(valorConvenioLocal.ConvCodigo);
    } catch (error: any) {
      console.log(error);
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefValor.current?.setErrors(errors);
        return;
      }

      addToast({
        type: 'error',
        title: 'Erro ao atualizar valor',
        description: error?.response?.data?.message
          ? error?.response?.data?.message
          : error.message,
      });
    } finally {
      setLoadingDelete(false);
    }
  }, [
    addToast,
    handleDeletou,
    valorConvenioLocal.ConvCodigo,
    valorConvenioLocal.ProCodigo,
    deleteValorConvenio,
  ]);

  return (
    <Form
      ref={formRefValor}
      initialData={valorConvenioLocal}
      onSubmit={handleAlterarValor}
      style={{ width: '100%' }}
    >
      <Row
        noGutters
        className={`py-2 border-bottom ${showAlterar ? 'bg-light' : ''}`}
        style={{ fontSize: 'Small' }}
        data-id={valorConvenio.ConvCodigo}
      >
        <Col sm={4} md={4} lg={6}>
          {valorConvenio.convenio}
        </Col>
        <Col sm={3} md={3} lg={2}>
          {!showAlterar && valorConvenioLocal.valorFormatado}

          {showAlterar && <InputMoney name="valor" placeholder="valor" />}
        </Col>
        <Col sm={2} md={2} lg={2}>
          {!showAlterar && valorConvenioLocal.ProRetorno}

          {showAlterar && <Input name="ProRetorno" placeholder="Dias" />}
        </Col>

        {!showAlterar && (
          <>
            <Col className="pl-2" sm={2} md={2} lg={1}>
              <Button
                type="button"
                variant="outline-primary"
                className="py-0"
                onClick={() => setShowAlterar(true)}
              >
                <FiEdit />
              </Button>
            </Col>

            <Col sm={1} md={1} lg={1}>
              <Button
                type="button"
                variant="outline-secondary"
                className="py-0"
                onClick={() => setShowExcluir(true)}
              >
                <FiTrash />
              </Button>

              {showExcluir && (
                <Modal
                  show={showExcluir}
                  titulo="Exclusão de valor"
                  handleFecharModal={() => setShowExcluir(false)}
                  large
                >
                  <h5 className="text-center">
                    Atenção essa operação não poderá ser desfeita!
                  </h5>
                  <h6 className="text-center">
                    Excluir valor de{' '}
                    <span className="text-danger">
                      {valorConvenioLocal.convenio}
                    </span>
                    ?
                  </h6>
                  <div className="d-flex justify-content-around mt-4">
                    <Button
                      type="button"
                      variant="secondary"
                      className="py-0"
                      disabled={loadingDelete}
                      onClick={() => setShowExcluir(false)}
                    >
                      Não, voltar
                    </Button>
                    <Button
                      type="button"
                      variant="outline-secondary"
                      className="py-0"
                      disabled={loadingDelete}
                      onClick={() => handleDeleteValor()}
                    >
                      sim, excluir
                    </Button>
                  </div>
                </Modal>
              )}
            </Col>
          </>
        )}
        {showAlterar && (
          <>
            <Col className="pl-2" sm={1} md={1} lg={1}>
              {!loading ? (
                <Button
                  type="button"
                  variant="outline-primary"
                  className="py-0"
                  title="Salvar"
                  disabled={loading}
                  onClick={() => formRefValor.current?.submitForm()}
                >
                  <FiSave size={16} />
                </Button>
              ) : (
                <div className="spinner-border" />
              )}
            </Col>

            <Col md={1} sm={1} lg={1}>
              <Button
                type="button"
                variant="outline-secondary"
                className="py-0"
                title="Cancelar"
                disabled={loading}
                onClick={() => setShowAlterar(false)}
              >
                <FiXCircle size={16} />
              </Button>
            </Col>
          </>
        )}
      </Row>
    </Form>
  );
};

export default LinhaValor;
